import Vue from 'vue';
import axios from 'axios';
import https from 'https';
import {
  Loading,
  Message
} from 'element-ui';
import {
  api
} from '~/ui-domain';
import Storage from './storage';
import store from '../store';
import router from '../router';
import checkToken from './checkToken';
const qs = require('qs');
window.env = process.env;
// 创建axios实例
// let headers = {}
// let arr = ["X-CID-Header","X-PBQ-Header","X-SID-Header","X-UID-Header","X-VID-Header"]
//     arr.forEach(x => {
//       headers[x] = sessionStorage.getItem(x) || ""
//     })

const service = axios.create({
  timeout: 1000 * 600, // 请求超时时间
  baseURL: api.buyer, // 买家端API
  // headers:headers,
  httpsAgent: new https.Agent({
    rejectUnauthorized: false,
  }),
  paramsSerializer: params => qs.stringify(params, {
    arrayFormat: 'repeat'
  }),
});

// request拦截器
service.interceptors.request.use(
  config => {
    if (/\/uploaders/.test(config.url)) {
      config.timeout = 0;
    }

    const {
      loading
    } = config;
    // 如果是put/post请求，用qs.stringify序列化参数
    const is_put_post = config.method === 'put' || config.method === 'post';
    if (config.url.indexOf('purang') !== -1) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
    const is_json = config.headers['Content-Type'] === 'application/json';

    // Message({
    //   // message:"config.headers.uuid",
    //   message:config.headers,
    //   // message:sessionStorage.getItem("X-UID-Header"),
    //   type:"success"
    // })
    // console.log(sessionStorage,"2222")
    const is_form_data = Object.prototype.toString.call(config.data) === '[object FormData]';
    if (is_put_post && is_json) {
      config.data = JSON.stringify(config.data);
    }
    if (is_put_post && !is_json && !is_form_data) {
      config.data = qs.stringify(config.data, {
        arrayFormat: 'repeat'
      });
    }

    if (config.url.indexOf('purang') !== -1) {
      config.data = qs.stringify(config.data, {
        arrayFormat: 'repeat'
      });
      // document.getElementById('zyz2336').innerHTML = JSON.stringify(config);
    }
    // console.log(config.data, 555)
    /** 配置全屏加载 */
    if (loading !== false) {
      config.loading = Loading.service({
        fullscreen: true,
        background: 'rgba(255,255,255,.3)',
        spinner: 'icon-custom-loading',
        lock: false,
      });
    }

    config.headers['uuid'] = Storage.getItem('uuid');

    // 获取访问Token
    console.log(Storage.getItem('access_token'), 112);
    let accessToken = Storage.getItem('access_token') || localStorage.getItem('access_token');
    if (accessToken && config.needToken) {
      config.headers['Authorization'] = accessToken;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  },
);

// respone拦截器
service.interceptors.response.use(
  async response => {
      if (response.data.status_flag == "true") {
        Message({
          message: response.data.message,
          type: "error"
        })
      }
      await closeLoading(response);
      return response.data;
    },
    async error => {
      await closeLoading(error);
      const error_response = error.response || {};
      const error_data = error_response.data || {};
      if (error_response.status === 403) {

        if (!Storage.getItem('refresh_token') && !localStorage.getItem('refresh_token')) return;
        store.dispatch('cart/cleanCartStoreAction');
        store.dispatch('user/removeUserAction');
        store.dispatch('user/removeAccessTokenAction');
        store.dispatch('user/removeRefreshTokenAction');
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        if (localStorage.getItem("from") && localStorage.getItem("from") == 'JRC') {
          console.log(window.location.href);
            let data = {
              fromShop: true,
              formShopUrl: window.location.href,
              data: '子页面主动触发通讯'
            };
          window.parent.postMessage(data, '*');
        } else {
          router.push(`/login`);
        }
        // router.push(`/login`);
        return Promise.reject(error);
      }
      if (!error.config || error.config.message !== false) {
        let _message = error.code === 'ECONNABORTED' ? '连接超时，请稍候再试！' : '网络错误，请稍后再试！';
        Vue.prototype.$message.error(error_data.message || _message);
      }
      return Promise.reject(error);
    },
);

/**
 * 关闭全局加载
 * @param target
 */
const closeLoading = target => {
  if (!target.config || !target.config.loading) return true;
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      target.config.loading.close();
      resolve();
    }, 200);
  });
};

export const Method = {
  GET: 'get',
  POST: 'post',
  PUT: 'put',
  DELETE: 'delete',
};

export default function request(options) {
  // 如果是服务端或者是请求的刷新token，不需要检查token直接请求。
  if (options.url.indexOf('passport/token') !== -1) {
    return service(options);
  }
  return new Promise((resolve, reject) => {
    checkToken(options).then(() => {
      service(options)
        .then(resolve)
        .catch(reject);
    });
  });
}



// WEBPACK FOOTER //
// ./src/utils/request.js